import React from 'react';

import { Container } from '@mui/material';
import { FlexBox, StyledHeader } from './Header.styles';
import { useWindowDimensions } from 'pages/AuthPage/AuthPage';
import Logo from 'utils/styles/Logo.styles';
import { getRuntimeTenantPortalUrl } from 'tenants/tenantConfigService';

const EmptyHeader = () => {
  const { width } = useWindowDimensions();

  if (width >= 600) return <span />;

  return (
    <StyledHeader>
      <Container>
        <FlexBox>
          <a
            href={getRuntimeTenantPortalUrl() || window.location.origin}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Logo />
          </a>
        </FlexBox>
      </Container>
    </StyledHeader>
  );
};

export default EmptyHeader;
